import '../../css/style.scss'
import {UIWProfileController} from './UIWProfileController.ts'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController.ts'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController.ts'
import {EntryShared} from '../../../shared/scripts/EntryShared.ts'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared.ts'
import {UIWManagerEvents} from '../ui_html/UIWManagerEvents.ts'

class EntryProfile extends EntryShared {
    constructor() {
        super()
        void this.init()
    }

    // eslint-disable-next-line class-methods-use-this
    async init() {
        EntryShared.initializeAudio()
        await EntryShared.initializeEntry()
        this.initializeUIManagerEvents(new UIWManagerEvents(undefined))

        new UIWProfileController()

        const headerController = new UIWHeaderController()
        new UISidebarController()

        EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    }
}

new EntryProfile()
